/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Who_4_DInputs */

const en_cp_who_4_d = /** @type {(inputs: Cp_Who_4_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Student leads get a free seat and a build-night kit; alumni and practitioners join as mentors and judges. Both free, both with a real role in the loop.`)
};

const id_cp_who_4_d = /** @type {(inputs: Cp_Who_4_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mahasiswa penggerak mendapat kursi gratis dan kit build night; alumni/praktisi masuk sebagai mentor dan juri. Keduanya gratis, keduanya punya peran nyata di loop.`)
};

/**
* | output |
* | --- |
* | "Student leads get a free seat and a build-night kit; alumni and practitioners join as mentors and judges. Both free, both with a real role in the loop." |
*
* @param {Cp_Who_4_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_who_4_d = /** @type {((inputs?: Cp_Who_4_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Who_4_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_who_4_d(inputs)
	return en_cp_who_4_d(inputs)
});